import {
	headingLevel1,
	headingLevel2,
	headingLevel3,
	headingLevel4,
	headingLevel5,
	headingLevel6,
} from '@wordpress/icons';

export const headingLevelOptions = [
	{ label: 'H1', value: '1', icon: headingLevel1 },
	{ label: 'H2', value: '2', icon: headingLevel2 },
	{ label: 'H3', value: '3', icon: headingLevel3 },
	{ label: 'H4', value: '4', icon: headingLevel4 },
	{ label: 'H5', value: '5', icon: headingLevel5 },
	{ label: 'H6', value: '6', icon: headingLevel6 },
];
